/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../kubb/client";
import type { Client, RequestConfig, ResponseErrorConfig, ResponseConfig } from "../../../kubb/client";
import type { GetFeedbackTokenQueryResponse, GetFeedbackTokenPathParams, GetFeedbackToken404, GetFeedbackToken429 } from "../models/GetFeedbackToken";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getFeedbackTokenQueryKey = ({ token }: { token: GetFeedbackTokenPathParams["token"] }) => [{ url: '/api/v1/contact/feedback/:token', params: {token:token} }] as const

export type GetFeedbackTokenQueryKey = ReturnType<typeof getFeedbackTokenQueryKey>

/**
 * @description Resolves a voice-of-driver feedback invite token to its link state (active / completed / expired / invalid). The first open transitions the invite sent → opened. Unknown tokens return 200 with state="invalid". Public endpoint — the token is the credential.
 * @summary Validate a feedback invite token
 * {@link /api/v1/contact/feedback/:token}
 */
export async function getFeedbackToken({ token }: { token: GetFeedbackTokenPathParams["token"] }, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetFeedbackTokenQueryResponse, ResponseErrorConfig<GetFeedbackToken404 | GetFeedbackToken429>, unknown>({ method : "GET", url : `/api/v1/contact/feedback/${token}`, ... requestConfig })
  return res
}

export function getFeedbackTokenQueryOptions({ token }: { token: GetFeedbackTokenPathParams["token"] }, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getFeedbackTokenQueryKey({ token })
        return queryOptions<ResponseConfig<GetFeedbackTokenQueryResponse>, ResponseErrorConfig<GetFeedbackToken404 | GetFeedbackToken429>, ResponseConfig<GetFeedbackTokenQueryResponse>, typeof queryKey>({
         enabled: !!(token),
         queryKey,
         queryFn: async ({ signal }) => {
            return getFeedbackToken({ token: token }, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Resolves a voice-of-driver feedback invite token to its link state (active / completed / expired / invalid). The first open transitions the invite sent → opened. Unknown tokens return 200 with state="invalid". Public endpoint — the token is the credential.
 * @summary Validate a feedback invite token
 * {@link /api/v1/contact/feedback/:token}
 */
export function useGetFeedbackToken<TData = ResponseConfig<GetFeedbackTokenQueryResponse>, TQueryData = ResponseConfig<GetFeedbackTokenQueryResponse>, TQueryKey extends QueryKey = GetFeedbackTokenQueryKey>({ token }: { token: GetFeedbackTokenPathParams["token"] }, options: 
{
  query?: Partial<QueryObserverOptions<ResponseConfig<GetFeedbackTokenQueryResponse>, ResponseErrorConfig<GetFeedbackToken404 | GetFeedbackToken429>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getFeedbackTokenQueryKey({ token })
         

         const query = useQuery({
          ...getFeedbackTokenQueryOptions({ token }, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetFeedbackToken404 | GetFeedbackToken429>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}